import React from 'react';

/** Teal square mark with Facebook-style lowercase t. */
export default function BrandMark({ size = 34, style, className, title = 'Transport Team', decorative = false }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 512 512"
      className={className}
      style={{ display: 'block', flexShrink: 0, ...style }}
      role={decorative ? 'presentation' : 'img'}
      aria-hidden={decorative || undefined}
      aria-label={decorative ? undefined : title}
    >
      <rect width="512" height="512" rx="96" fill="#0d7377" />
      <g fill="#fff">
        <rect x="116" y="112" width="292" height="78" rx="39" />
        <rect x="188" y="152" width="78" height="260" rx="39" />
      </g>
    </svg>
  );
}
